import { useCallback, useMemo, useRef, useState } from "react";

export function useSelectionStaleness(selectedIds: ReadonlySet<string>) {
  const [lastCalculatedSelectionIds, setLastCalculatedSelectionIds] = useState<
    string[] | null
  >(null);
  const lastRequestedSelectionIdsRef = useRef<string[]>([]);

  const markSelectionRequested = useCallback((ids: string[]) => {
    lastRequestedSelectionIdsRef.current = ids;
  }, []);

  const markSelectionCalculated = useCallback(() => {
    setLastCalculatedSelectionIds(lastRequestedSelectionIdsRef.current);
  }, []);

  const hasUnappliedSelectionChanges = useMemo(() => {
    if (!lastCalculatedSelectionIds) return false;
    if (lastCalculatedSelectionIds.length !== selectedIds.size) return true;
    return lastCalculatedSelectionIds.some((id) => !selectedIds.has(id));
  }, [lastCalculatedSelectionIds, selectedIds]);

  return {
    markSelectionRequested,
    markSelectionCalculated,
    hasUnappliedSelectionChanges,
  };
}
